module.exports = __webpack_public_path__ + "images/patterns/light/StripeVertical.bff0791556d4eac08e56.svg";